'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PackageRemoveConfirmationDesktop = require('./PackageRemoveConfirmationDesktop.js');
var PackageRemoveConfirmationMobile = require('./PackageRemoveConfirmationMobile.js');
var PackageRemoveConfirmationViewRoot = require('../../../../common/views/PackageRemoveConfirmation/PackageRemoveConfirmationViewRoot.js');
var useIsMobile = require('../../../../common/providers/useIsMobile.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageRemoveConfirmation = () => {
  const isMobile = useIsMobile["default"]();
  return /*#__PURE__*/React__default["default"].createElement(PackageRemoveConfirmationViewRoot["default"], null, isMobile ? /*#__PURE__*/React__default["default"].createElement(PackageRemoveConfirmationMobile["default"], null) : /*#__PURE__*/React__default["default"].createElement(PackageRemoveConfirmationDesktop["default"], null));
};

exports["default"] = PackageRemoveConfirmation;
